export default __webpack_public_path__ + "static/media/heartFill.44028196.svg";